import { render, staticRenderFns } from "./SchoolIntegrationQuestion.vue?vue&type=template&id=19ef7879&scoped=true"
import script from "./SchoolIntegrationQuestion.vue?vue&type=script&lang=js"
export * from "./SchoolIntegrationQuestion.vue?vue&type=script&lang=js"
import style0 from "./SchoolIntegrationQuestion.vue?vue&type=style&index=0&id=19ef7879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ef7879",
  null
  
)

export default component.exports